import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import { isNativePlatform } from "./lib/capacitor";
import { normalizeMobileRoute, shouldUseH5Client } from "./lib/client-routing";
import { SiteSettingsProvider } from "./lib/site-settings";

const path = window.location.pathname;
const normalizedPath = path.toLowerCase();
const isAdmin = normalizedPath.startsWith("/admin");
const isMobileWebClient = !isNativePlatform && shouldUseH5Client({
  viewportWidth: window.innerWidth,
  userAgent: window.navigator.userAgent,
  platform: window.navigator.platform,
  maxTouchPoints: window.navigator.maxTouchPoints,
});

if (!isAdmin && isMobileWebClient) {
  const mobilePath = normalizeMobileRoute(path);
  if (mobilePath !== path) {
    window.history.replaceState(window.history.state, "", `${mobilePath}${window.location.search}${window.location.hash}`);
  }
}

// Website child routes are mounted at the root domain. They must be classified
// here as Website routes too, otherwise a hard refresh falls through to the
// mobile App router even though the client-side menu navigation was correct.
const isWebsiteChildRoute = /^\/(following|nearby|topics|treehole|profile|publish|notifications|search|chat(?:\/|$)|topic(?:\/|$)|board(?:\/|$)|post(?:\/|$)|user(?:\/|$))(?:\/|$)/i.test(path);

// The browser Website owns the root and its direct routes. Mobile browsers and
// narrow desktop windows use the H5 App router, including the `/login` entry.
const isWebsite = !isNativePlatform && !isMobileWebClient && (
  path === "/"
  || normalizedPath.startsWith("/website")
  || normalizedPath.startsWith("/pc")
  || isWebsiteChildRoute
);

if (!isAdmin && !isWebsite) {
  import("./styles/app.css");
}

const AdminApp = isAdmin ? React.lazy(() => import("./admin/AdminApp")) : null;
const WebsiteEntry = isWebsite ? React.lazy(() => import("./website/index")) : null;
const AppRouter = isNativePlatform ? HashRouter : BrowserRouter;

function PageLoading() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div>加载中...</div>
    </div>
  );
}

export default function Root() {
  return <SiteSettingsProvider><RootContent /></SiteSettingsProvider>;
}

function RootContent() {
  if (isAdmin && AdminApp) {
    return <React.Suspense fallback={<PageLoading />}><AdminApp /></React.Suspense>;
  }
  if (isWebsite && WebsiteEntry) {
    return <React.Suspense fallback={<PageLoading />}><WebsiteEntry /></React.Suspense>;
  }
  return <AppRouter><App /></AppRouter>;
}
